export default "__VITE_ASSET__C3wt5gyW__"